/* tslint:disable */
/* eslint-disable */
/**
 * Product Page Aggregator
 * Aggregator for the product page on web and native apps
 *
 * The version of the OpenAPI document: 1
 * Contact: mark.salt@autotrader.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FeatureHighlightsItemsFromJSON, FeatureHighlightsItemsToJSON, } from './FeatureHighlightsItems';
/**
 * @export
 */
export const FeatureHighlightsByCategoryCategoryEnum = {
    Optional: 'OPTIONAL',
    Rare: 'RARE',
    Valuable: 'VALUABLE'
};
/**
 * Check if a given object implements the FeatureHighlightsByCategory interface.
 */
export function instanceOfFeatureHighlightsByCategory(value) {
    if (!('featureItems' in value) || value['featureItems'] === undefined)
        return false;
    return true;
}
export function FeatureHighlightsByCategoryFromJSON(json) {
    return FeatureHighlightsByCategoryFromJSONTyped(json, false);
}
export function FeatureHighlightsByCategoryFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'title': json['title'] == null ? undefined : json['title'],
        'category': json['category'] == null ? undefined : json['category'],
        'count': json['count'] == null ? undefined : json['count'],
        'featureItems': (json['featureItems'].map(FeatureHighlightsItemsFromJSON)),
    };
}
export function FeatureHighlightsByCategoryToJSON(json) {
    return FeatureHighlightsByCategoryToJSONTyped(json, false);
}
export function FeatureHighlightsByCategoryToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'title': value['title'],
        'category': value['category'],
        'count': value['count'],
        'featureItems': (value['featureItems'].map(FeatureHighlightsItemsToJSON)),
    };
}
